import AppShell from '@components/AppShell'
import { AuthWrapper } from '@features/auth'
import { createMonitoredRouter } from '@lib/sentry-routing'
import type { RouteObject } from 'react-router'
import { AppCrashFallback } from 'shared-ui/components'

import { path } from './paths'
import { privateRoutes } from './PrivateRoutes'
import { publicRoutes } from './PublicRoutes'

export const appRoutes: RouteObject[] = [
  {
    element: <AuthWrapper />,
    errorElement: <AppCrashFallback error={new Error('Top-level crash')} />, // TODO: better fallback
    children: [
      {
        element: <AppShell />,
        children: [
          {
            path: path.publicLanding,
            children: publicRoutes
          },
          {
            children: privateRoutes
          }
        ]
      }
    ]
  }
]

export const router = createMonitoredRouter(appRoutes)
